import { ErrorHandler } from '@angular/core';

export class AppErrorHandler implements ErrorHandler {
  handleError(error) {
    console.warn('An unexpected error occured.');
    console.warn(error);
  }
}
